import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  styled,
  Link,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { getApiCall, postApiCall } from "../../../../utils/api";
import Swal from "sweetalert2";

const DropZone = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff4e6",
  padding: theme.spacing(5),
  textAlign: "center",
  cursor: "pointer",
  borderRadius: 8,
  border: "2px dashed #ff9900",
}));

const Bulk = ({ setIsOpen, fetchData }) => {
  const [validData, setValidData] = useState([]);
  const [invalidCount, setInvalidCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [schoolData, setSchoolData] = useState([]);
  const [schoolId, setSchoolId] = useState("");

  useEffect(() => {
    // setStudentData([])
    fetchDataInit();
  }, []);
  const fetchDataInit = async () => {
    setLoading(true);
    const res = await getApiCall("admin/get-all-schools");
    console.log(res);

    setSchoolData(res.data);
    setLoading(false);
  };

  const processData = (data) => {
    let valid = [];
    let invalid = 0;

    data.slice(1).forEach((row) => {
      const [name, cls, phone, email] = row;

      if (name?.trim() && cls?.toString().trim()) {
        valid.push({
          name: name.trim(),
          class: Number(cls),
          phone: phone ? phone.toString().trim() : "",
          email: email ? email.toString().trim() : "",
          school_id: schoolId,
          role: "admin",
          parent_name: name.trim(),
        });
      } else {
        invalid++;
      }
    });
    console.log("DATA", valid);

    setValidData(valid);
    setInvalidCount(invalid);
  };

  const handleFileUpload = (e) => {
    console.log("asdads", e.target.files?.[0]);

    if (schoolId === "") {
      alert("Please select a school before uploading the file.");
      return;
    }

    const file = e.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();
    console.log("123", fileExtension);

    if (fileExtension === "csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: function (results) {
          processData(results.data);
        },
      });
    } else if (fileExtension === "xlsx") {
      const reader = new FileReader();
      reader.onload = function (event) {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        processData(parsedData);
      };
      reader.readAsArrayBuffer(file);
    } else {
      alert("Please upload a CSV or XLSX file");
    }
  };

  const handleCancel = () => {
    setValidData([]);
    setInvalidCount(0);
    if (setIsOpen) setIsOpen(false);
  };

  const handleSubmit = async () => {
    try {
      const res = await postApiCall("student/register-invite-students-bulk", {
        bulk_student_upload_data: validData,
      });

      if (res.success === false) {
        if (setIsOpen) setIsOpen(false);

        return Swal.fire({
          title: "Error",
          text: res.message,
          icon: "error",
        });
      }
      Swal.fire({
        title: "Successful",
        text: res.message,
        icon: "success",
      });
      fetchData();

      if (setIsOpen) setIsOpen(false);
      if (setIsOpen) setIsOpen(false);
    } catch (err) {
      console.error("Submission error:", err);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* <Typography variant="body2" sx={{ mb: 2 }}>
        You can add new students here. New students must have their data in the
        list and get their credentials after listing.
      </Typography> */}

      <Typography sx={{ mb: 1 }}>
        Tip:{" "}
        <Link href="/NRSM_Upload_Sample.xlsx" download underline="hover" color="orange">
          Download Sample File Here (Do not remove the header from the sample file)
        </Link>
      </Typography>
      <FormControl fullWidth required>
        <InputLabel>Select School</InputLabel>
        <Select
          name="school_id"
          value={schoolId}
          onChange={(e) => setSchoolId(e.target.value)}
          label="School"
          displayEmpty
          required
        >
          <MenuItem value="" disabled>
            Select School
          </MenuItem>
          {schoolData.map((cls) => (
            <MenuItem key={cls.id} value={cls.id}>
              {cls.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <br />
      <br />

      <DropZone component="label">
        Drag & Drop or Upload Bulk Data (.csv or .xlsx)
        <input
          type="file"
          accept=".csv, .xlsx"
          hidden
          onChange={handleFileUpload}
        />
      </DropZone>

      {(validData.length > 0 || invalidCount > 0) && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ✅ Valid Entries: {validData.length}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            ❌ Invalid Entries Skipped: {invalidCount}
          </Typography>
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={validData.length === 0}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default Bulk;
